import { CardModel, PileCardModel, PileModel } from "../../interface/game";
import { PileClickPolicy } from "./pile-click-policy";

export function pileClickRevealToPile(destPileId: string, count: number, faceUp: boolean = true): PileClickPolicy {
    return (pileId: string, piles: {[key: string]: PileModel}, cards: {[key: string]: CardModel}) => {
        const sourcePile = piles[pileId];
        const destPile = piles[destPileId];
        if (sourcePile === undefined || destPile === undefined) {
            return [];
        }

        let n = 0;
        while (n<count && sourcePile.cards.length>0) {
            const card = sourcePile.cards.pop() as PileCardModel;
            cards[card.id] = {...cards[card.id], faceUp: faceUp};
            destPile.cards.push(card);
            n++;
        }

        return [pileId, destPileId];
    };
}